import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-588b882a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "index-banner-content",
  style: `background-color:red;`
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "max-section section banner-word" }
const _hoisted_4 = { class: "title fs-50 c0 fw-500 mb-20" }
const _hoisted_5 = { class: "des fs-22 c9" }


export default /*#__PURE__*/_defineComponent({
  props: {
    bannerArr: { type: Array, required: true }
  },
  setup(__props: any) {


const onChange = (current: number) => {
  console.log(current);
};

return (_ctx: any,_cache: any) => {
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createBlock(_component_a_carousel, { "after-change": onChange }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.bannerArr, (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "banner-img",
            src: item.pictureUrl,
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.description), 1)
          ])
        ]))
      }), 256))
    ]),
    _: 1
  }))
}
}

})